import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import LatestAddressSection from "./components/LatestAddressSection";
import CategorySection from "./components/CategorySection";
import FeaturedArticlesSection from "./components/FeaturedArticlesSection";
import FAQSection from "./components/FAQSection";
import SafetyTipsSection from "./components/SafetyTipsSection";

const pageTitle = "91.con官方入口·最新地址导航 | 91.con网址导航";
const pageDescription =
  "91.con是用户热搜的网络平台入口，本页提供91.con最新可用地址、安全访问指引及常见问题解答，帮助用户快速找到91.con官方渠道，收藏本页随时获取最新更新。";
const pageKeywords = "91.con,91.con最新地址,91.con官方入口,91.con访问指引,91.con网址导航,91.con常见问题";
const canonicalUrl = "https://91con-nav.com/";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl={canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=91con%20official%20website%20navigation%20portal%20with%20warm%20amber%20color%20scheme%2C%20clean%20modern%20design%2C%20abstract%20geometric%20network%20connections%2C%20professional%20corporate%20aesthetic&width=1200&height=630&seq=og-home-v1&orientation=landscape"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: "91.con 导航",
          url: canonicalUrl,
          description: pageDescription,
        }}
        scriptId="schema-org"
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "91.con 导航",
          url: canonicalUrl,
          description: pageDescription,
          potentialAction: {
            "@type": "SearchAction",
            target: `${canonicalUrl}search?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        }}
        scriptId="schema-website"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          description: pageDescription,
          url: canonicalUrl,
          isPartOf: {
            "@type": "WebSite",
            name: "91.con 导航",
            url: canonicalUrl,
          },
        }}
        scriptId="schema-webpage"
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "91.con 是什么平台？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "91.con 是一个广受用户欢迎的综合网络平台，提供丰富的在线服务和内容。",
              },
            },
            {
              "@type": "Question",
              name: "如何找到 91.con 的最新官方地址？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "您可以通过以下方式获取最新地址：收藏本导航页面、关注官方社交媒体账号、加入官方用户交流群。",
              },
            },
            {
              "@type": "Question",
              name: "为什么 91.con 的地址会经常变化？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "由于网络环境的复杂性，平台地址可能会因技术维护、网络优化或外部因素而调整，目的是为用户提供更稳定安全的访问体验。",
              },
            },
            {
              "@type": "Question",
              name: "91.con 是否安全？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "91.con 官方平台使用 HTTPS 加密传输和多重安全防护措施保障用户数据和隐私安全。",
              },
            },
            {
              "@type": "Question",
              name: "如何避免访问到虚假的 91.con 网站？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "通过本导航站获取地址，不点击来历不明的链接；检查地址栏是否有 HTTPS 安全锁；核对域名拼写是否完全正确。",
              },
            },
          ],
        }}
        scriptId="schema-faq"
      />

      <Navbar />

      <main>
        <HeroSection />
        <LatestAddressSection />
        <CategorySection />
        <FeaturedArticlesSection />
        <FAQSection />
        <SafetyTipsSection />
      </main>

      <Footer />
    </>
  );
}